import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  details: {
    record: {},
    total: 0,
  },
};

const getters = {
  details: state => state.details.record,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
